// Import Rankers components
// Components are behaviour tied to a DOM element.

import { analyticsListenerLoader } from '../../rankers/components/analytics_listener/analytics_listener_loader';
analyticsListenerLoader();

import { analyticsWatcherLoader } from '../../rankers/components/analytics_watcher/analytics_watcher_loader';
analyticsWatcherLoader();

import { pageHeadingLoader } from '../../rankers/components/page_heading/page_heading_loader';
pageHeadingLoader();

import { dropdownLoader } from '../../rankers/components/dropdown/dropdown_loader';
dropdownLoader();

import { breakpointerLoader } from '../../rankers/components/breakpointer/breakpointer_loader';
breakpointerLoader();

import { togglerBtnsLoader } from '../../rankers/components/toggler_btns/toggler_btns_loader';
togglerBtnsLoader();

import { togglerLinkLoader } from '../../rankers/components/toggler_link/toggler_link_loader';
togglerLinkLoader();

import { reviewLoader } from '../../rankers/components/review/review_loader';
reviewLoader();

import { avatarLoader } from '../../rankers/components/avatar/avatar_loader';
avatarLoader();

import { moreFetcherLoader } from '../../rankers/components/more_fetcher/more_fetcher_loader';
moreFetcherLoader();
